import { DatePipe, NgIf, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { DsBadgeComponent } from '@design-system/ds-badge/component/ds-badge.component';
import { DsButtonComponent } from '@design-system/ds-button/component/ds-button.component';
import { DsIconComponent } from '@design-system/ds-icon/component/ds-icon.component';
import { DsTextComponent } from '@design-system/ds-text/component/ds-text.component';
import { ServiceRequestFlag } from '@modals/service-request-flags/interfaces/service-request-flag.interface';

@Component({
  selector: 'app-active-flags-table',
  templateUrl: './active-flags-table.component.html',
  styleUrls: ['./active-flags-table.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, DatePipe, UpperCasePipe, MatTableModule, DsBadgeComponent, DsButtonComponent, DsIconComponent, DsTextComponent],
})
export class ActiveFlagsTableComponent {
  @Input() flags: ServiceRequestFlag[] = [];

  @Output() readonly editFlag = new EventEmitter<ServiceRequestFlag>();
  @Output() readonly resolveFlag = new EventEmitter<ServiceRequestFlag>();

  readonly displayedColumns: string[] = ['category', 'followUpTime', 'reason', 'actions'];
}
